import { forwardRef } from 'react';
import { IconButton, styled } from '@mui/material';
import { useThemeProps } from '@mui/material/styles';
import { LinkedIn } from '@mui/icons-material';

export interface ShareOnLinkedInButtonProps {
    url?: string;
    title?: string;
    summary?: string;
}

const ShareOnLinkedInButtonRoot = styled(IconButton, {
    name: 'MuiShareOnLinkedInButton',
    slot: 'root',
})({});

export const ShareOnLinkedInButton = forwardRef<HTMLButtonElement, ShareOnLinkedInButtonProps>(
    function ShareOnLinkedInButton(inProps, ref) {
        const props = useThemeProps({ props: inProps, name: 'MuiShareOnLinkedInButton' });
        const { url, title, summary } = props;
        const myUrlWithParams = new URL('http://www.linkedin.com/shareArticle?mini=true');
        if (url) {
            myUrlWithParams.searchParams.append('url', url);
        }
        if (title) {
            myUrlWithParams.searchParams.append('title', title);
        }
        if (summary) {
            myUrlWithParams.searchParams.append('summary', summary);
        }

        return (
            <ShareOnLinkedInButtonRoot
                ref={ref}
                aria-label="LinkedIn Icon"
                color="primary"
                size="small">
                <a href={myUrlWithParams.href} target="_blank" rel="noopener noreferrer">
                    <LinkedIn />
                </a>
            </ShareOnLinkedInButtonRoot>
        );
    }
);

export default ShareOnLinkedInButton;
